import { render, staticRenderFns } from "./BudgetsView.vue?vue&type=template&id=13afd391&scoped=true&lang=pug"
import script from "./BudgetsView.vue?vue&type=script&lang=js"
export * from "./BudgetsView.vue?vue&type=script&lang=js"
import style0 from "./BudgetsView.vue?vue&type=style&index=0&id=13afd391&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13afd391",
  null
  
)

export default component.exports